import React from 'react';
import './Pages.css';

function Privacy() {
  return (
    <div className="container">
      <div className="page-content">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: January 2025</p>

        <div className="page-section">
          <p>
            Welcome to Stickyours.com. Your privacy is important to us, and this Privacy Policy
            explains how we collect, use, and protect your information when you use our Image to
            Sticker Generator and related tools.
          </p>
        </div>

        <div className="page-section">
          <h2>Information We Collect</h2>
          <p>
            Stickyours.com does not require users to create an account to use our tools.
          </p>
          <p>We may collect:</p>
          <ul>
            <li>
              Non-personal information such as browser type, device type, and usage statistics for
              improving performance.
            </li>
            <li>
              Uploaded images, which are used only for processing your request.
            </li>
          </ul>
        </div>

        <div className="page-section">
          <h2>Image Processing & Data Usage</h2>
          <ul>
            <li>Images uploaded to Stickyours.com are processed only to generate stickers.</li>
            <li>We do not sell, share, or use your images for training or marketing.</li>
            <li>
              Uploaded images are not permanently stored and are automatically deleted after
              processing or within a short time.
            </li>
          </ul>
        </div>

        <div className="page-section">
          <h2>Cookies</h2>
          <p>We may use cookies or similar technologies to:</p>
          <ul>
            <li>Improve website performance</li>
            <li>Analyze traffic and usage patterns</li>
          </ul>
          <p>You can disable cookies through your browser settings.</p>
        </div>

        <div className="page-section">
          <h2>Third-Party Services</h2>
          <p>
            Stickyours.com may use third-party tools such as analytics services to understand
            website performance. These services may collect anonymized data in accordance with
            their own privacy policies.
          </p>
        </div>

        <div className="page-section">
          <h2>Data Security</h2>
          <p>
            We implement reasonable security measures to protect your information. However, no
            online service can guarantee 100% security.
          </p>
        </div>

        <div className="page-section">
          <h2>Children's Privacy</h2>
          <p>
            Stickyours.com is not intended for children under the age of 13. We do not knowingly
            collect personal data from children.
          </p>
        </div>

        <div className="page-section">
          <h2>Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Any changes will be posted on
            this page.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
